import React, { useEffect, useState } from "react"
import { API_URL } from "../../utils/config"
import BoardView from "../../components/warehouseBoard/BoardView"

// tog'a #3457/#3460 (2026-10-04): omborda katta monitor — login'siz «Табло склада» (/board/<token>). Faqat ko'rish, 10 soniyada yangilanadi.
// Havolani admin «Табло склада» → «📺 Ссылка для монитора» da yaratadi va istalgan payt o'chiradi (o'chsa — «Ссылка недействительна»).
export default function WarehouseBoardPublic() {
  const token = (window.location.pathname.split("/board/")[1] || "").split(/[/?#]/)[0]
  const [data, setData] = useState<any>(null)
  const [meta, setMeta] = useState<any>({})
  const [error, setError] = useState<string | null>(null)
  useEffect(() => {
    let stop = false
    const load = async () => {
      try {
        const r = await fetch(`${API_URL}WarehouseDesk/Board/${token}`)
        if (r.status === 404) { if (!stop) { setError("Ссылка недействительна или отключена — обратитесь к администратору"); setData(null) } return }
        if (!r.ok) { if (!stop) setError(null); return }   // vaqtinchalik xato — eski ma'lumot qoladi
        const j = await r.json()
        if (!stop) { setData(j.board); setMeta(j); setError(null) }
      } catch { /* tarmoq uzildi — keyingi urinishda */ }
    }
    load()
    const id = setInterval(load, 10000)
    // ekran o'chib qolmasin (qo'llab-quvvatlasa)
    let lock: any = null
    try { (navigator as any).wakeLock?.request("screen").then((l: any) => (lock = l)).catch(() => {}) } catch { }
    return () => { stop = true; clearInterval(id); try { lock?.release() } catch { } }
  }, [token])
  useEffect(() => { document.title = "Табло склада" + (meta?.warehouse ? " — " + meta.warehouse : "") }, [meta?.warehouse])
  return <BoardView data={data} error={error} sub={[meta?.warehouse, meta?.name].filter(Boolean).join(" · ") || meta?.tenant} />
}
